import axios from "axios";

const { REACT_APP_DISPLAY_API_URL } = process.env;
const baseUrl = `${REACT_APP_DISPLAY_API_URL}/slides`;
console.assert(REACT_APP_DISPLAY_API_URL, "REACT_APP_API_URL is not defined");

export const getSlideById = (id: string) => {
  return axios.get(`${baseUrl}/id/${id}`);
};
